import React from 'react';
import { core as Core } from 'zingchart-react';
import commonChartConfig from "components/common/charts/commonchartconfig"
/* This component is used in
components/pages/comparison/charts/index.jsx
components/pages/comparison/charts/rangechart/index.jsx
components/pages/stats/occupancyrange/rangechartcontainer.jsx
*/
const RangeChart = (props) => {
    let values = []
    values.push({ values: props.values, backgroundColor: props.values1 ? "#60aff4" : "#3cb449" });
    /* because the linechart default value of first line is blue and rangechart is green,
     hence push values1 with color blue at the begining of the array value
     this fixes color label issue in range chart in comparison page.
     */
    props.values1 && values.push({ values: props.values1, backgroundColor: "#3cb449" })

    var myConfig = Object.assign({}, commonChartConfig, {
        type: "bar",
        plotarea: {
            backgroundColor: "#f6f7fa"
        },
        scaleX: {
            labels: ["0%", "0-20%", "20-40%", "40-60%", "60-80%", "80-100%", "100%"],
            minorTicks: 0
        },
        scaleY: {
            lineColor: "#f6f7f8",
            shadow: 0,
            format: "%vhr",
            guide: {
                lineStyle: "dashed",
                lineColor: "white"
            },
            minorTicks: 0,
            thousandsSeparator: ","
        },
        plot: {
            barWidth: "50px",
            /*rules: [
                   props.values1 ?
                       (
                           {
                               rule: " %p==0 && %n==0 || %n==6",
                               backgroundColor: "#60aff4" // values0(pale-blue)
                           },
                           {
                               rule: " %p===1 && %n===0 || %n===6",
                               backgroundColor: "#93d69b" // values1(pale-green)
                           }
                       )
                       :
                       {
                           rule: " %p===0 && %n===0 || %n===6",
                           backgroundColor: "#93d69b" // values1(pale-green)
                       }
               ]*/
            rules: [
                {
                    rule: " %p==0 && %node-index ==0 || %p==0 && %node-index==6 ",
                    backgroundColor: props.values1 ? "#95c1e5" : "#dfdfdf"
                },
                {
                    rule: " %p==1 && %node-index ==0 || %p==1 && %node-index==6",
                    backgroundColor: props.values1 ? "#93d69b" : "#dfdfdf"
                }
            ]

            // animation: {
            //     effect: 1,
            //     sequence: 2,
            //     speed: 100
            // }
        },
        series: values
    });
    return (
        <div>
            <Core id={props.id} data={myConfig} height="450px" width="100%" />
        </div>
    );
}
export default RangeChart


// WEBPACK FOOTER //
// ./src/components/common/charts/rangechart.jsx